export const icons = {
  CLOSE: 'close',
  MAIL: 'mail_outline',
  EYE: 'remove_red_eye',
  PERSON: 'person',
  LOGOUT: 'power_settings_new',
};
